import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'auth',
    component: MsalRedirectComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home-module/home/home.component').then(
        (m) => m.HomeComponent
      ),
    canActivate: [MsalGuard],
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
];